var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{staticClass:"date",attrs:{"datetime":_vm.datetime},domProps:{"textContent":_vm._s(_vm.date)}})}
var staticRenderFns = []

export { render, staticRenderFns }